export default {
  title: 'Archivos',
  dropTitle: 'Arrastra el archivo aquí',
  select: 'o haz clic para elegir',

  states: {
    error: 'Error de carga',
    success: 'Archivo cargado',
    loading: 'Cargando archivo'
  },

  drop: 'Arrastra el archivo aquí para cargarlo'
}
